import { useCallback, useContext } from 'react';
import {
	PerformanceAnalyticsContext,
	type PerformanceEvents,
} from '../provider/PerformanceAnalytics';

export const getPerformanceMark = () => Math.trunc(performance.now());

export const usePerformanceAnalytics = ({ isEnabled }: { isEnabled: boolean }) => {
	const { eventsRef } = useContext(PerformanceAnalyticsContext);

	const captureEvent = useCallback(
		(event: PerformanceEvents) => {
			if (!isEnabled) {
				return;
			}
			eventsRef.current.push(event);
		},
		[isEnabled, eventsRef],
	);

	return { captureEvent };
};
